import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\ContactFrom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\OurImpact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\Services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\papermill\\Desktop\\project\\perftecht\\src\\app\\components\\Testimonials.tsx");
